export const productPromotionConstants = {
    GET_PP_SUCCESS: "GET_PP_SUCCESS",
    PERSONAL_APPEARANCE_STATUS: [
     "dispute_started",//0
    ],
};
